module.exports = __webpack_public_path__ + "static/media/admin.2a7f4cde.png";